import { Trans, useTranslation } from 'react-i18next';
import { getDateFormatted, getTimeAgo } from 'shared/dates';
import { GeoEventMetadataText } from './GeoEventMetadataText';

export type GeoEventCreatedByLineProps = {
  createdByName: { displayNameShort?: string | null };
  dateCreated: Date | string;
  isActive: boolean;
  /** Embed cards use shorter copy without full timestamps. */
  variant?: 'default' | 'embed';
  'data-testid'?: string;
};

export const GeoEventCreatedByLine = (
  props: GeoEventCreatedByLineProps,
): JSX.Element => {
  const {
    createdByName,
    dateCreated,
    isActive,
    variant = 'default',
    'data-testid': dataTestId = 'createdBy',
  } = props;
  const { t } = useTranslation();

  const timeAgo = isActive ? getTimeAgo(dateCreated) : null;

  const authorName = createdByName.displayNameShort || t('geoEvent.watchDuty');

  if (variant === 'embed') {
    if (timeAgo) {
      return (
        <GeoEventMetadataText data-testid={dataTestId}>
          <Trans
            i18nKey="geoEvent.embed.createdByTimeAgo"
            values={{ name: authorName, timeAgo }}
          >
            Created by <b>Watch Duty</b> • 1 day ago
          </Trans>
        </GeoEventMetadataText>
      );
    }

    return (
      <GeoEventMetadataText data-testid={dataTestId}>
        <Trans i18nKey="geoEvent.embed.createdBy" values={{ name: authorName }}>
          Created by <b>Watch Duty</b>
        </Trans>
      </GeoEventMetadataText>
    );
  }

  if (timeAgo) {
    return (
      <GeoEventMetadataText data-testid={dataTestId}>
        <Trans
          i18nKey="geoEvent.createdByTimeAgo"
          values={{
            name: authorName,
            dateFormatted: getDateFormatted(dateCreated),
            timeAgo,
          }}
        >
          Created by <b>Watch Duty</b> • 1 day ago • Aug 4 at 12:54 PM
        </Trans>
      </GeoEventMetadataText>
    );
  }

  return (
    <GeoEventMetadataText data-testid={dataTestId}>
      <Trans
        i18nKey="geoEvent.createdBy"
        values={{
          name: authorName,
          dateFormatted: getDateFormatted(dateCreated, {
            includeYear: true,
          }),
        }}
      >
        Created by <b>Watch Duty</b> • Aug 4, 2024 at 12:54 PM
      </Trans>
    </GeoEventMetadataText>
  );
};
